import React from "react";
import {
    // Button,
    Modal,
    OverlayTrigger,
    Popover
} from "react-bootstrap";
import { helperFunctions as HF } from "../../../helper/helperFunctions";

import SimpleReactValidator from "simple-react-validator";
import Select from "react-select";
import ModuleForm from "../Module/ModuleForm";

class PermissionForm extends React.Component {
    constructor(props) {
        super(props);
        this.validatorPermission = new SimpleReactValidator();
        this.state = {
            permission: { ...this.props.permissionPro },
            submitted: false,
            formType: this.props.formTypePro || "",
            ModuleModalShow: false
        };
        this.handlePermission = this.handlePermission.bind(this);
        this.handlePermissionSubmit = this.handlePermissionSubmit.bind(this);
        this.handleChangePermissionType = this.handleChangePermissionType.bind(
            this
        );
        this.handleChangeParentLabel = this.handleChangeParentLabel.bind(this);
        this.handleChangeIcon = this.handleChangeIcon.bind(this);
        this.handleChangeOrder = this.handleChangeOrder.bind(this);
        this.handleIsmenuCheckBox = this.handleIsmenuCheckBox.bind(this);
        this.handleModuleChange = this.handleModuleChange.bind(this);
        this.openModalModule = this.openModalModule.bind(this);
        this.closeModalModule = this.closeModalModule.bind(this);
    }

    handleIsmenuCheckBox(e) {
        const { value } = e.target;
        const permissionStatePer = { ...this.state.permission };
        permissionStatePer["is_menu"] = value === "on" ? 0 : 1;
        this.setState({ permission: permissionStatePer });
    }
    handleChangePermissionType(selectedOptionType) {
        const permissionState = { ...this.state.permission };
        if (selectedOptionType.value === "label") {
            permissionState["permission_type"] = selectedOptionType.value;
            permissionState["parent_label"] = null;
        } else {
            permissionState["permission_type"] = selectedOptionType.value;
        }
        this.setState({ permission: permissionState }, function() {});
    }
    handleChangeParentLabel(selectedOptionParent, name) {
        const permissionState = { ...this.state.permission };
        if (name.action === "select-option") {
            permissionState["parent_label"] = selectedOptionParent.value;
        }
        if (name.action === "clear") {
            permissionState["parent_label"] = "";
        }
        this.setState({ permission: permissionState }, function() {});
    }
    handleChangeIcon(selectedOptionParent, name) {
        const permissionState = { ...this.state.permission };
        if (name.action === "select-option") {
            console.log(selectedOptionParent.value);
            permissionState["icon"] = selectedOptionParent.value;
        }
        if (name.action === "clear") {
            permissionState["icon"] = "";
        }
        this.setState({ permission: permissionState }, function() {});
    }
    handleChangeOrder(selectedOptionOrder) {
        const permissionState = { ...this.state.permission };
        permissionState["order"] = selectedOptionOrder.value;
        this.setState({ permission: permissionState }, function() {});
    }
    handlePermission(e) {
        const { name, value } = e.target;
        const permissionState = { ...this.state.permission };
        permissionState[name] = value;
        this.setState({ permission: permissionState });
    }
    handlePermissionSubmit(e) {
        e.preventDefault();
        if (this.validatorPermission.allValid()) {
            this.setState({ submitted: true }, function() {
                this.props.handlePermissionSubmit(
                    this.state.permission,
                    this.state.formType
                );
            });
        } else {
            this.setState({ submitted: false });
            this.validatorPermission.showMessages();
            this.forceUpdate();
        }
    }

    /**
     *
     * @param {selectedOption} selected
     * Handle Module dropdown change
     */
    handleModuleChange(selected) {
        if ("select-option") {
            const permission = { ...this.state.permission };
            permission["module_id"] = selected;
            this.setState(
                {
                    permission: permission
                },
                function() {
                    console.log("permission state", this.state.permission);
                }
            );
        }
    }

    /**
     * Open modal to create new module
     */
    openModalModule() {
        this.setState({
            ModuleModalShow: true
        });
    }

    /**
     * Close Modal module
     */
    closeModalModule() {
        this.setState({
            ModuleModalShow: false
        });
    }

    render() {
        this.validatorPermission.purgeFields();
        const { permission, formType } = this.state;
        const {
            moduleOptions,
            optionsParent,
            optionsType
        } = this.props;

        const icons = [
            { label: "dashboard.png", value: "dashboard.png" },
            { label: "brandManagement.png", value: "brandManagement.png" },
            { label: "brands.png", value: "brands.png" },
            { label: "tagLayout.png", value: "tagLayout.png" },
            { label: "dataDefinition.png", value: "dataDefinition.png" },
            { label: "lookupDefinition.png", value: "lookupDefinition.png" },
            {
                label: "customerManagement.png",
                value: "customerManagement.png"
            },
            { label: "customers.png", value: "customers.png" },
            { label: "shippingOptions.png", value: "shippingOptions.png" },
            { label: "orderManagement.png", value: "orderManagement.png" },
            { label: "orderList.png", value: "orderList.png" },
            { label: "openCarts.png", value: "openCarts.png" },
            { label: "productManagement.png", value: "productManagement.png" },
            { label: "manuallySynced.png", value: "manuallySynced.png" },
            { label: "recentlySynced.png", value: "recentlySynced.png" },
            { label: "productStyles.png", value: "productStyles.png" },
            { label: "settings.png", value: "settings.png" },
            { label: "manageLists.png", value: "manageLists.png" },
            { label: "configSettings.png", value: "configSettings.png" },
            { label: "aclManagement.png", value: "aclManagement.png" },
            { label: "users.png", value: "users.png" },
            { label: "contacts.png", value: "contacts.png" },
            { label: "addresses.png", value: "addresses.png" },
            { label: "permissions.png", value: "permissions.png" },
            { label: "roles.png", value: "roles.png" }
        ];

        return (
            <div>
                <form onSubmit={this.handlePermissionSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="name">
                                    Permission Name
                                    <span className="requiredClass">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="name"
                                    className="form-control"
                                    value={permission.name}
                                    onChange={this.handlePermission}
                                />
                                {this.validatorPermission.message(
                                    "permissionName",
                                    permission.name,
                                    "required"
                                )}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="name">
                                    Label
                                    <span className="requiredClass">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="label"
                                    className="form-control"
                                    value={permission.label}
                                    onChange={this.handlePermission}
                                />
                                {this.validatorPermission.message(
                                    "label",
                                    permission.label,
                                    "required"
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="">
                                <label className="container-check checkbox_down">
                                    {" "}
                                    Is Menu?
                                    <input
                                        type="checkbox"
                                        name="is_menu"
                                        className="checkbox"
                                        value={
                                            permission.is_menu ? "on" : "off"
                                        }
                                        onChange={this.handleIsmenuCheckBox}
                                        checked={permission.is_menu}
                                    />
                                    <span className="checkmark"></span>
                                </label>
                                {/* {this.validatorPermission.message('is_menu', permission.is_menu, 'required')} */}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="name">Icon</label>
                                <Select
                                    value={HF.returnLabelWithValue(
                                        permission.icon,
                                        icons
                                    )}
                                    onChange={this.handleChangeIcon}
                                    options={icons}
                                    isSearchable={false}
                                    name="icon"
                                    isMulti={false}
                                    placeholder={"Select Icon"}
                                />
                                {/* this.validatorPermission.message('icon', permission.icon, 'required') */}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8">
                            <div className="form-group">
                                <label>
                                    Select Module
                                    <span className="requiredClass">*</span>
                                </label>
                                <Select
                                    value={permission.module_id}
                                    options={moduleOptions}
                                    isSearchable={true}
                                    onChange={this.handleModuleChange}
                                    isMulti={false}
                                    placeholder={"Select Module"}
                                />
                                {this.validatorPermission.message(
                                    "module",
                                    permission.module_id,
                                    "required"
                                )}
                            </div>
                        </div>
                        <div className="col-md-4">
                            {
                                //hasPermission('permission-create') &&
                                <OverlayTrigger
                                    trigger="focus"
                                    placement="bottom"
                                    overlay={
                                        <Popover id="tooltip">
                                            Add Module
                                        </Popover>
                                    }
                                >
                                    <button
                                        type="button"
                                        style={{ marginTop: "22px" }}
                                        className="backButton pt-sm no_radius pb-sm primary btn btn-block btn-sm customBtn btnBlue"
                                        onClick={this.openModalModule}
                                    >
                                        <i className="fa fa-plus" />
                                        Module
                                    </button>
                                </OverlayTrigger>
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="name">Description?</label>
                                <textarea
                                    type="text"
                                    name="description"
                                    className="form-control"
                                    value={permission.description}
                                    onChange={this.handlePermission}
                                ></textarea>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="name">
                                    Select Permission Type
                                    <span className="requiredClass">*</span>
                                </label>
                                <Select
                                    value={HF.returnLabelWithValue(
                                        permission.permission_type,
                                        optionsType
                                    )}
                                    onChange={this.handleChangePermissionType}
                                    options={optionsType}
                                    isSearchable={true}
                                    isMulti={false}
                                    placeholder={"Select Permission Type"}
                                />
                                {this.validatorPermission.message(
                                    "permission_type",
                                    permission.permission_type,
                                    "required"
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label htmlFor="name">
                                    Select Parent Label
                                </label>
                                <Select
                                    value={HF.returnLabelWithValue(
                                        permission.parent_label,
                                        optionsParent
                                    )}
                                    onChange={this.handleChangeParentLabel}
                                    options={optionsParent}
                                    isSearchable={true}
                                    isMulti={false}
                                    isClearable={true}
                                    placeholder={"Select Permission"}
                                />
                            </div>
                        </div>
                        {permission.permission_type === "url" && (
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="path">
                                        Path
                                        <span className="requiredClass">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="path"
                                        className="form-control"
                                        value={permission.path}
                                        onChange={this.handlePermission}
                                    />
                                    {this.validatorPermission.message(
                                        "path",
                                        permission.path,
                                        "required"
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-center">
                                <button
                                    type="submit"
                                    className="backButton pt-sm no_radius pb-sm success btn btn-lg btn-info ml-sm mt-sm btn-default customBtn"
                                    style={{ width: "25%" }}
                                >
                                    Save
                                </button>
                                {formType === "edit" && (
                                    <button
                                        type="button"
                                        onClick={() => this.props.closeModel()}
                                        className="backButton pt-sm no_radius pb-sm primary btn btn-lg ml-sm mt-sm customBtn btnBlue"
                                        style={{ width: "25%" }}
                                    >
                                        Cancel
                                    </button>
                                )}
                                {formType === "add" && (
                                    <button
                                        type="button"
                                        onClick={() => this.props.closeModel()}
                                        className="backButton pt-sm no_radius pb-sm primary btn btn-lg ml-sm mt-sm customBtn btnBlue"
                                        style={{ width: "25%" }}
                                    >
                                        Cancel
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </form>
                <Modal
                    show={this.state.ModuleModalShow}
                    onHide={this.closeModalModule}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Add Module</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ModuleForm closed={this.closeModalModule} />
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export default PermissionForm;



// WEBPACK FOOTER //
// ./src/components/Admin/Permissions/PermissionForm.jsx